import React, { useState } from 'react';
import { styled, AppBar, Toolbar, Button, Box, IconButton, Drawer, List, ListItem, ListItemText } from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import TTCLogo from "../images/TTC_Logo.png";
import { isMobile } from 'react-device-detect';
import { getAuth, signOut } from "firebase/auth";
import {useNavigate}from 'react-router-dom';

const StyledToolbar = styled(Toolbar)({
  boxShadow: "none",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  height: "100%",
  padding: 0,
});

const NavBarButton = styled(Button)({
  fontSize: "18px",
  color: "black",
  boxShadow: "none",
  textTransform: "none",
  alignItems: "left",
  margin: "5px",
  "&:hover": {
    backgroundColor: "inherit",
    boxShadow: "none",
  },
});

const auth = getAuth();


const NavToolbar = ({ isAuthenticated }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setDrawerOpen(open);
  };

  const navigate = useNavigate();
  function handleClick()
  {
      signOut(auth).then(() => {
          navigate('/login');
      }).catch((error) => {
  
      });
  }

  const drawerList = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem button component={Link} to="/">
          <ListItemText primary="Home" />
        </ListItem>
        <ListItem button component={Link} to="/resourcestab/resources">
          <ListItemText primary="Resources" />
        </ListItem>
        <ListItem button component={Link} to="/hotlines">
          <ListItemText primary="Hotlines" />
        </ListItem>
        {!isAuthenticated ? (
          null
        ) : (
          <ListItem button component={Link} to="/resource-form">
            <ListItemText primary="Add/Update Resource" />
          </ListItem>
        )}
        {!isAuthenticated ? (
          null
        ) : (
          <ListItem button component={Link} to="/admin-hotlines">
            <ListItemText primary="Add/Update Hotlines" />
          </ListItem>
        )}
        {!isAuthenticated ? (
          null
        ) : (
          <ListItem button onClick={handleClick}>
            <ListItemText primary="Logout" />
          </ListItem>
        )}
      </List>
    </Box>
  );

  return (
    <AppBar color="white" position="static" sx={{ height: "15vh", boxShadow: "none", padding: 0 }}>
      <StyledToolbar>
        <Box class=" justify-center w-[10%] max-[1440px]:w-[5%] h-fit mt-[5px]" sx={{paddingLeft: isMobile ? 0 : "4vw"}}>
          <NavBarButton component={Link} to="/" display="inline" disableRipple >
            <div className='flex justify-center'>
              <div className='flex justify-center max-h-[70px] max-w-[70px]'>
                <img src={TTCLogo} align="left" alt="logo" />
              </div>
              <p className='text-sm text-[#016C9D] font-bold max-[1440px]:hidden max-w-[70px]'>Tippy County Connect</p>
            </div>
          </NavBarButton>
        </Box>
        <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: "center", gap: 2, paddingRight: "5vw" }}>
          <NavBarButton component={Link} to="/" disableRipple>Home</NavBarButton>
          <NavBarButton component={Link} to="/resourcestab/resources" disableRipple>Resources</NavBarButton>
          <NavBarButton component={Link} to="/hotlines" disableRipple>Hotlines</NavBarButton>
          {!isAuthenticated ? (
            null
          ) : (
            <NavBarButton component={Link} to="/resource-form" disableRipple>Add/Update Resource</NavBarButton>
          )}
          {!isAuthenticated ? (
            null
          ) : (
            <NavBarButton component={Link} to="/admin-hotlines" disableRipple>Add/Update Hotlines</NavBarButton>
          )}
          {!isAuthenticated ? (
            null
          ) : (
            <NavBarButton onClick={handleClick} disableRipple>Logout</NavBarButton>
          )}
        </Box>
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ display: { xs: 'block', md: 'none' }, marginRight: '16px' }}
          onClick={toggleDrawer(true)}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <MenuIcon />
            <span>Menu</span>
          </Box>
        </IconButton>
        <Drawer
          anchor="right"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
        >
          {drawerList}
        </Drawer>
      </StyledToolbar>
    </AppBar>
  );
};

export default NavToolbar;
